import { SendClientInviteDTO } from './dto/send-client-invite.dto';
import { AcceptClientInviteDTO } from './dto/accept-client-invite.dto';
import backendHttpClient from '../../../http/axios/axios-http-client';

export interface ClientGateway {
  inviteClient(props: SendClientInviteDTO, token?: string): Promise<void>;
  acceptInvitation(props: AcceptClientInviteDTO, token?: string): Promise<void>;
}

export class ClientGateway implements ClientGateway {
  async inviteClient(props: SendClientInviteDTO, token?: string) {
    const endpoint = `/client-invite/invite`;
    await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: {
        email: props.email,
        firstName: props.firstName,
        lastName: props.lastName,
        phoneNumber: props.phoneNumber,
      },
    });
  }

  async acceptInvitation(props: AcceptClientInviteDTO, token?: string) {
    const endpoint = `/public/client-invite/accept`;
    await backendHttpClient.request({
      url: endpoint,
      method: 'POST',
      data: {
        inviteId: props.clientInviteId,
        password: props.password,
      },
    });
  }
}
